import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IMeetingOutCome, IMeetingOutComeState } from "./meetingoutcomeModel";
import {
  createMeetingOutCome,
  deleteMeetingOutCome,
  getAllActiveMeetingOutCome,
  getAllMeetingOutCome,
  getMeetingOutComeByID,
  MeetingOutComeActiveInactive,
  updateMeetingOutCome,
} from "./services/meetingoutcome.service";

const initialState: IMeetingOutComeState = {
  loading: false,
  formLoading: false,
  error: "",
  MeetingOutComeList: [],
  MeetingOutComeID: null,
  MeetingOutComeDetail: {
    meeting_outcome: "",
    isactive: 1,
  },
};

const meetingoutcomeSlice = createSlice({
  name: "meetingoutcome",
  initialState,
  reducers: {
    clearMeetingOutComeDetails: (state) => {
      state.MeetingOutComeDetail = initialState.MeetingOutComeDetail;
    },
    setMeetingOutComeID: (state, action) => {
      state.MeetingOutComeID = action.payload;
    },
    clearMeetingOutComeID: (state) => {
      state.MeetingOutComeID = initialState.MeetingOutComeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMeetingOutCome.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllMeetingOutCome.fulfilled,
      (state, action: PayloadAction<IMeetingOutCome[]>) => {
        state.loading = false;
        state.MeetingOutComeList = action.payload || [];
      }
    );
    builder.addCase(getAllMeetingOutCome.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingOutComeList = [];
    });
    builder.addCase(getAllActiveMeetingOutCome.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveMeetingOutCome.fulfilled,
      (state, action: PayloadAction<IMeetingOutCome[]>) => {
        state.loading = false;
        state.MeetingOutComeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveMeetingOutCome.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingOutComeList = [];
    });
    builder.addCase(createMeetingOutCome.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createMeetingOutCome.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createMeetingOutCome.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateMeetingOutCome.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateMeetingOutCome.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateMeetingOutCome.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteMeetingOutCome.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMeetingOutCome.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMeetingOutCome.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(MeetingOutComeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(MeetingOutComeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(MeetingOutComeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getMeetingOutComeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getMeetingOutComeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.MeetingOutComeDetail = action.payload;
    });
    builder.addCase(getMeetingOutComeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.MeetingOutComeDetail = initialState.MeetingOutComeDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearMeetingOutComeDetails,
  setMeetingOutComeID,
  clearMeetingOutComeID,
} = meetingoutcomeSlice.actions;
export default meetingoutcomeSlice.reducer;
